import React from "react";
import { View, StyleSheet, Text, Platform } from "react-native";
import MoodsHelper from "./MoodsHelper";
import AppTheme from "../../AppTheme";

export default function MoodsList({
  selectedMood = {},
  onSelect = () => {},
  showTitle = false,
  title = "How do you feel?",
}) {
  const moods = MoodsHelper.getMoods();
  const UNSET_MOOD = MoodsHelper.UNSET_MOOD;

  const onMoodSelected = (m) => {
    const newMood = m == selectedMood ? null : m;
    onSelect(newMood);
  };

  return (
    <View style={styles.container}>
      {showTitle ? <Text style={styles.header}>{title}</Text> : null}

      <View style={styles.wrapper}>
        {moods.map((m, index) => (
          <m.Icon
            key={index}
            onPress={() => onMoodSelected(m.value)}
            selected={selectedMood == m.value}
            style={styles.icon}
            color={selectedMood == m.value ? m.color : UNSET_MOOD.color}
          />
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    width: 264,
    minHeight: 46,
    maxWidth: "100%",
  },
  icon: {
    width: 36,
    height: 36,
    borderRadius: 36,
    backgroundColor: "transparent",
  },
  header: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "500",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    width: "100%",
    textAlign: "center",
  },
});
